import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbb29448"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-wizard" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_view = _resolveComponent("client-view")!
  const _component_project_view = _resolveComponent("project-view")!
  const _component_process_view = _resolveComponent("process-view")!
  const _component_dates_view = _resolveComponent("dates-view")!
  const _component_variables_view = _resolveComponent("variables-view")!
  const _component_placeholder_view = _resolveComponent("placeholder-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_client_view, {
        onUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clientData = $event))
      }),
      _createVNode(_component_project_view, {
        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.projectData = $event)),
        clientId: _ctx.clientData?.clientId
      }, null, 8, ["clientId"]),
      _hoisted_3,
      _createVNode(_component_process_view, {
        onUpdate: _cache[2] || (_cache[2] = ($event: any) => {_ctx.processData = $event; _ctx.loadPlaceholder(); _ctx.loadVariables()})
      }),
      _createVNode(_component_dates_view, {
        onUpdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.datesData = $event)),
        hideInputIcon: true
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "btn btn-dark w-100",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step = 2)),
        disabled: !_ctx.canContinue,
        value: "Continue"
      }, "Continue", 8, _hoisted_5)
    ], 512), [
      [_vShow, _ctx.step === 1]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_variables_view, {
        clientId: _ctx.clientData?.clientId,
        variables: _ctx.variables
      }, null, 8, ["clientId", "variables"]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "btn btn-outline-dark me-2",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.step = 1))
        }, "Back"),
        _createElementVNode("button", {
          class: "btn btn-dark w-100",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.step = 3)),
          disabled: !_ctx.canContinue,
          value: "Continue"
        }, "Continue", 8, _hoisted_8)
      ])
    ], 512), [
      [_vShow, _ctx.step === 2]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_placeholder_view, {
        onNext: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitCall())),
        onPrev: _cache[8] || (_cache[8] = ($event: any) => (_ctx.step--)),
        onUpdate: _cache[9] || (_cache[9] = ($event: any) => {_ctx.placeholderMatching = $event;}),
        clientId: _ctx.clientData?.clientId,
        placeholders: _ctx.placeholders
      }, null, 8, ["clientId", "placeholders"]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "btn btn-outline-dark me-2",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.step = 2))
        }, "Back"),
        _createElementVNode("div", {
          class: "btn btn-dark w-100",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submitCall()))
        }, "Create project & process")
      ])
    ], 512), [
      [_vShow, _ctx.step === 3]
    ])
  ]))
}